import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { GET_BENEFICIARIES_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetBeneficiariesApiRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_BENEFICIARIES_URL;

  constructor(paramList) {
    super();
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
